export default __webpack_public_path__ + "static/media/search.7010d73e.svg";